<script setup>
definePage({
  meta: {
    layout: 'default',
    action: 'credential-manage',
    subject: 'Hr',
  },
})

const page = {
  groupTitle: 'Kepegawaian (HR)',
  icon: 'ri-award-line',
  color: 'info',
  title: 'Kredensial Pegawai (STR/SIP)',
  description: 'Mencatat dan memperbarui tanggal berlaku STR/SIP pegawai.',
  purpose: 'Panduan mencatat masa berlaku Surat Tanda Registrasi (STR) dan Surat Izin Praktik (SIP) pegawai, plus lampiran dokumennya.',
  concept: [
    {
      icon: 'ri-notification-3-line',
      title: 'Reminder Otomatis',
      text: 'Begitu Anda mengisi tanggal berlaku STR/SIP, sistem otomatis mengingatkan menjelang tanggal itu habis — Anda tidak perlu mengingat sendiri kapan harus memperpanjang.',
    },
  ],
  steps: [
    { title: 'Buka menu Kepegawaian → Kredensial Pegawai', detail: 'Cari nama pegawai yang dicari.' },
    { title: 'Klik nama pegawai untuk membuka detail kredensial', detail: 'Isi/ubah tanggal berlaku STR dan/atau SIP.' },
    { title: 'Lampirkan scan dokumen STR/SIP', detail: 'Lewat tombol lampiran di halaman yang sama.' },
    { title: 'Klik "Simpan"', detail: 'Status kredensial (Berlaku/Segera Berakhir/Kedaluwarsa) langsung terlihat di daftar.' },
  ],
  tips: [
    'Perbarui tanggal begitu STR/SIP baru diterima — memperbarui tanggal otomatis menghentikan reminder yang lama dan memulai reminder baru untuk tanggal berikutnya.',
  ],
  faq: [
    { q: 'Kenapa saya masih dapat reminder padahal sudah perpanjang STR?', a: 'Pastikan Anda benar-benar sudah menyimpan tanggal berlaku yang BARU di halaman ini — reminder mengikuti tanggal yang tersimpan di sistem, bukan yang sebenarnya terjadi di dunia nyata.' },
  ],
  related: [
    { title: 'Reminder & Pengingat', sub: 'Rekap semua pengingat jatuh tempo', icon: 'ri-notification-3-line', color: 'info', to: { name: 'help-kepegawaian-reminder-pengingat' } },
  ],
}
</script>

<template>
  <GuidePageLayout v-bind="page" />
</template>
